const influencerSectionid = new Swiper(
  "#influencerSection-id .influencerSectionSwiper",
  {
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
      410: {
        slidesPerView: 2,
      },
      500: {
        slidesPerView: 2,
      },
      724: {
        slidesPerView: 3,
      },
      940: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1216: {
        slidesPerView: 5,
      },
      1400: {
        slidesPerView: 6,
      },
    },
    navigation: {
      nextEl: "#influencerSection-id .swiper-button-next",
      prevEl: "#influencerSection-id .swiper-button-prev",
    },
  }
);

const latestReleases = new Swiper(".latest-releases-swiper", {
  slidesPerView: 1,
  spaceBetween: 12,
  breakpoints: {
    500: {
      slidesPerView: 1.5,
    },
    724: {
      slidesPerView: 2,
    },
    940: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 2.75,
    },
    1400: {
      slidesPerView: 3,
    },
  },
  navigation: {
    nextEl: ".team-pc-latest-releases .swiper-button-next",
    prevEl: ".team-pc-latest-releases .swiper-button-prev",
  },
});
